
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XImg from 'vux/src/components/x-img/index.vue'

export default {
directives: {
TransferDom
},
components: {
Previewer,
XImg
},
props: {
hasDetail: {
type: Boolean,
default: true
},
item: {
type: Object,
default: {}
}
},
data () {
return {
plist: [],
width: '750'
}
},
beforeDestroy () {

},

computed: {

},
watch: {

},
mounted() {

},
methods: {
onLink(url){
if(!this.hasDetail){
return;
}
this.util.urlCommon(url, this, { path: url });
},

showPreviewer (e, index) {
var newIndex = index;

if(typeof e != 'number'){
let $dom = $(e.target).parents('.img_box');
if(!$dom.attr('data-img')){
$dom.find('span').each(function(i, item){
$(item).css('background-image', 'url('+$(item).attr('data-src')+')');
})
$dom.attr('data-img', '1');
}
}else{
newIndex = e;
}

this.plist = this.item.sku_images.map(n=>{
let o = {...n};
o.msrc = o.compress_file_url;
o.src = o.compress_file_url.split(',w_')[0] + ',w_' + this.width;
o.w = o.width < this.width ? o.width : this.width;
o.h = Math.ceil(o.w / o.r);
return o;
})
this.$nextTick(()=>{
this.$refs.previewer.show(newIndex)
})
},
}
}



// WEBPACK FOOTER //
// ./src/components/askDetail/askDetail.vue